module.exports = __webpack_public_path__ + "img/banner_img.b658441f.png";